<template>
  <div class="pdf-preview">
    <button v-if="pdfUrl" class="close-btn" @click="handleClose">✕</button>
    <!-- 当 pdfUrl 存在时，显示 iframe 预览 -->
    <iframe
        v-if="pdfUrl"
        :src="viewerUrl"
        width="100%"
        height="100%"
        frameborder="0"
        @load="handleLoad"
        @error="handleError"
    ></iframe>

    <!-- 加载中状态 -->
    <div v-else-if="loading" class="status loading">
      <span>加载预览中...</span>
    </div>

    <!-- 错误或无地址提示 -->
    <div v-else class="status error">
      <span>{{ errorMessage || '暂无预览文件' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PDFPreview',
  props: {
    // 接收父组件传入的 PDF 文件地址（签名 URL 或公共 URL）
    pdfUrl: {
      type: String,
      default: ''
    },
    // 可选：是否显示加载状态（父组件可控制）
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      errorMessage: '' // 内部错误信息
    };
  },
  computed: {
    /**
     * 构建 PDF.js 查看器的完整 URL
     * 将 pdfUrl 进行编码后作为 file 参数传递给 viewer.html
     */
    viewerUrl() {
      if (!this.pdfUrl) return '';
      // 假设 PDF.js 的 viewer.html 位于 /pdfjs/web/viewer.html
      const encodedUrl = encodeURIComponent(this.pdfUrl);
      return `/pdfjs/web/viewer.html?file=${encodedUrl}`;
    }
  },
  watch: {
    // 当 pdfUrl 变化时，重置错误信息
    pdfUrl() {
      this.errorMessage = '';
    }
  },
  methods: {
    handleLoad() {
      // iframe 加载成功时触发，可以通知父组件
      this.$emit('load');
    },
    handleError() {
      // iframe 加载失败时触发
      this.errorMessage = '预览加载失败，请稍后重试';
      this.$emit('error', new Error('PDF iframe 加载失败'));
    },
    handleClose() {
      // 通知父组件关闭预览
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: 600px;
  border: 1px solid #e8e8e8;
  background-color: #f5f5f5;
  position: relative;
  overflow: hidden;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  font-size: 20px;
  cursor: pointer;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}

.status {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  font-size: 16px;
  color: #999;
}
.status.error { color: #f56c6c; }
iframe { border: none; display: block; }
</style>